<template>
  <div class="card-group"  :class="{'stockcss': stocktheme==='stockcss'}">
    <div class="card shadow" v-for="getstock in getstocks" :key="getstock.hp1id">
      <!-- <img class="card-img-top" src="" alt="Card image cap"> -->
      <div class="card-body">
        <!-- <h5 class="card-title">Card title</h5> -->
        <p class="card-text" v-html="getstock.moreinfo"></p>
        <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default{
props: ['getstocks', 'stocktheme', 'stockresizerowstheme']
}
</script>

<style scoped>
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */

 .card-group {
  margin-left: 250px;
  margin-right: 250px;
 }
 @media only screen and (max-width: 600px) {
  .col {
    width: 100%;
  }

 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .col {
    width: 100%;
  }
  .row {
    margin: 0 auto;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .col {
    width: 33%;
    }
  .row {
    margin: 0 auto;
  }
 }

 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
  .col {
    width: 33%;
    }
  .row {
    margin: 0 auto;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .col {
    width: 33%;
    }
  .row {
    margin: 0 auto;
  }
}

 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1400px) {


  .stockcss {
    width: 68%;
  }

}

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1600px) {
    .col {
      width: 33%;
      }
    .row {
      margin: 0 auto;
    }
}
 
</style>